'use client';

import { FC } from 'react';
import { CatHeading } from 'components/blocks-components';
import { useSelectItemEvent } from 'hooks/analytics/use-select-item-event';
import { getFormattedSearchSelectItem } from 'components/product-comparison-grid/product-comparison-card/utils';
import { ALTERNATE_PARTS_LIST } from '../../../../constants/constants';
import styles from '../alternate-parts.module.scss';
import Link from 'next/link';
import { useAlternateContext } from '../alternate-parts-context/alternate-context-provider';
import { getProductWithPartNumber } from '../utils';

interface AlternatePartTitleWrapperProps {
  partNumber: string;
  name: string;
  storeLocationId: string;
}

const AlternatePartTitleWrapper: FC<AlternatePartTitleWrapperProps> = ({
  partNumber,
  name,
  storeLocationId
}) => {
  const { fireEvent: fireSelectItemEvent } = useSelectItemEvent();
  const { priceAndAvailability, cartDetails } = useAlternateContext();

  const handleSelectItemGa = () => {
    const product = getProductWithPartNumber(partNumber, priceAndAvailability);
    fireSelectItemEvent({
      item: getFormattedSearchSelectItem(cartDetails?.orderHeader, product),
      partName: `${product?.partNumber}: ${product?.name}`,
      locationId: storeLocationId,
      itemSummary: product,
      isSearchPageEvent: true,
      itemListId: ALTERNATE_PARTS_LIST,
      itemListName: ALTERNATE_PARTS_LIST,
      serialNumber: '',
      fitment: ''
    });
  };

  return (
    <section
      id="alternate-part-title"
      className={`mb-2 ${styles['alternate-part-title']}`}
    >
      <CatHeading
        variant="label-lg"
        level="h3"
        className={styles['alternate-part-title__heading']}
      >
        <Link
          href={partNumber}
          onClick={handleSelectItemGa}
          className={styles['alternate-part-title__anchor-link']}
        >
          {`${partNumber}: ${name}`}
        </Link>
      </CatHeading>
    </section>
  );
};

export default AlternatePartTitleWrapper;
